import { useParams } from 'react-router-dom';
import MapViewer from "./map-viewer";

const MapViewerContainer = () => {
    const { clientId, projectId } = useParams<any>();
    

const totalLatitude = 100;
const totalLongitude = 100;

// Generate 10,000 borehole locations
// workout the number of boreholes per row and column to fit all around the world based on the total number of totalX and totalY
const minimumLatitude = -85;
const maximumLatitude = 85;
const minimumLongitude = -180;
const maximumLongitude = 180;
// Calculate the step size for latitude and longitude
const latitudeStep = (maximumLatitude - minimumLatitude) / totalLongitude;  
const longitudeStep = (maximumLongitude - minimumLongitude) / totalLatitude;


var number = 1;
var boreholeLocations: any[] = [];
for (let latitude = 0; latitude < totalLatitude; latitude++) {
    for (let longitude = 0; longitude < totalLongitude; longitude++) {
        boreholeLocations.push({   
            "id": `borehole-${number}`,    
            "number": number,
            "name": `Test ${number}`,
            "latitude": maximumLatitude - (latitude * latitudeStep),
            "longitude": minimumLongitude + (longitude * longitudeStep),
        }); 
        number++;
    }
}
    
    return(
        <div>
            {boreholeLocations && <MapViewer boreholeLocations={boreholeLocations} projectId={projectId} clientId={clientId} /> }
        </div>
    )
}

export default MapViewerContainer;